// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "./assets/bundle." + chunkId + "" + "3665f8fa70f3a1d3c4e2" + ".js";
};